var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import TomSelect from "tom-select/dist/cjs/tom-select.popular";
document.addEventListener("turbo:load", () => {
  const isOnSelectRecipientsPage = window.location.pathname.includes("/select_recipients_to_deliver");
  const selectors = {
    form: document.querySelector(".form.newsletter_deliver"),
    sendToAllUsers: document.querySelector("#newsletter_send_to_all_users"),
    sendToVerifiedUsers: document.querySelector("#newsletter_send_to_verified_users"),
    sendToParticipants: document.querySelector("#newsletter_send_to_participants"),
    sendToFollowers: document.querySelector("#newsletter_send_to_followers"),
    sendToMembers: document.querySelector("#newsletter_send_to_members"),
    verificationTypesSelect: document.querySelector("#verification_types_for_select"),
    participatorySpacesForSelect: document.querySelector("#participatory_spaces_for_select"),
    deliverButton: document.querySelector("#deliver-button"),
    confirmRecipientsLink: document.querySelector("#confirm-recipients-link"),
    recipientsCount: document.querySelector("#recipients_count"),
    recipientsCountSpinner: document.querySelector("#recipients_count_spinner"),
    csrfToken: document.querySelector('meta[name="csrf-token"]')
  };
  const inputs = {
    radioButtons: [selectors.sendToAllUsers, selectors.sendToVerifiedUsers].filter(Boolean),
    checkboxes: [
      selectors.sendToParticipants,
      selectors.sendToFollowers,
      selectors.sendToMembers
    ].filter(Boolean)
  };
  const toggleVisibility = (element, condition) => element == null ? void 0 : element.classList.toggle("hidden", !condition);
  const updateDeliverButtonVisibility = () => {
    var _a, _b;
    const sendToAllUsersChecked = ((_b = (_a = selectors.form) == null ? void 0 : _a.elements["newsletter[send_to_all_users]"]) == null ? void 0 : _b.value) === "1";
    toggleVisibility(selectors.deliverButton, sendToAllUsersChecked);
    toggleVisibility(selectors.confirmRecipientsLink, !sendToAllUsersChecked);
  };
  const updateHiddenField = (input) => {
    var _a;
    const hiddenInput = (_a = selectors.form) == null ? void 0 : _a.elements[input.name];
    if (hiddenInput) {
      hiddenInput.value = input.checked ? "1" : "0";
    }
  };
  const ensureAtLeastOneOptionSelected = () => {
    if (![...inputs.radioButtons, ...inputs.checkboxes].some((input) => input == null ? void 0 : input.checked)) {
      selectors.sendToAllUsers.checked = true;
      updateHiddenField(selectors.sendToAllUsers);
    }
  };
  const updateConfirmRecipientsLink = () => {
    if (!selectors.confirmRecipientsLink) {
      return;
    }
    const params = new URLSearchParams(new FormData(selectors.form));
    selectors.confirmRecipientsLink.setAttribute(
      "href",
      `${selectors.confirmRecipientsLink.dataset.baseUrl}?${params.toString()}`
    );
  };
  const updateRecipientsCount = () => __async(null, null, function* () {
    var _a, _b, _c, _d, _e;
    const url = (_b = (_a = selectors.form) == null ? void 0 : _a.dataset) == null ? void 0 : _b.recipientsCountNewsletterPath;
    if (!url) {
      return;
    }
    (_c = selectors.recipientsCountSpinner) == null ? void 0 : _c.classList.remove("hide");
    try {
      const response = yield fetch(url, {
        method: "POST",
        headers: { "X-CSRF-Token": (_d = selectors.csrfToken) == null ? void 0 : _d.content },
        body: new FormData(selectors.form)
      });
      selectors.recipientsCount.textContent = yield response.text();
    } catch (error) {
      console.error("Error fetching recipients count:", error);
    } finally {
      (_e = selectors.recipientsCountSpinner) == null ? void 0 : _e.classList.add("hide");
    }
  });
  const resetIdsForParticipatorySpaces = () => {
    document.querySelectorAll('.form.newsletter_deliver select[name$="[ids][]"]').forEach((select) => {
      if (select.tomselect) {
        select.tomselect.clear();
      } else {
        select.value = [];
      }
    });
  };
  const resetVerificationTypes = () => {
    var _a, _b;
    const select = document.querySelector("#verification-types-select");
    (_a = select == null ? void 0 : select.tomselect) == null ? void 0 : _a.clear();
    const hiddenInput = (_b = selectors.form) == null ? void 0 : _b.elements["newsletter[verification_types]"];
    if (hiddenInput) {
      hiddenInput.value = "";
    }
  };
  const updateFormState = () => {
    var _a, _b, _c;
    [...inputs.radioButtons, ...inputs.checkboxes].forEach(updateHiddenField);
    const isAllUsersChecked = (_a = selectors.sendToAllUsers) == null ? void 0 : _a.checked;
    const isAnyChecked = [...inputs.radioButtons, ...inputs.checkboxes].some((input) => input == null ? void 0 : input.checked);
    toggleVisibility(selectors.deliverButton, isAllUsersChecked);
    toggleVisibility(selectors.confirmRecipientsLink, !isAllUsersChecked && isAnyChecked);
    toggleVisibility(
      selectors.participatorySpacesForSelect,
      inputs.checkboxes.some((input) => input.checked) && !((_b = selectors.sendToVerifiedUsers) == null ? void 0 : _b.checked)
    );
    toggleVisibility(selectors.verificationTypesSelect, (_c = selectors.sendToVerifiedUsers) == null ? void 0 : _c.checked);
    ensureAtLeastOneOptionSelected();
    updateConfirmRecipientsLink();
    updateRecipientsCount();
  };
  const handleRadioChange = (radio) => {
    inputs.radioButtons.forEach((rb) => rb.checked = rb === radio);
    inputs.checkboxes.forEach((checkbox) => checkbox.checked = false);
    resetVerificationTypes();
    resetIdsForParticipatorySpaces();
    updateFormState();
  };
  const handleCheckboxChange = () => {
    inputs.radioButtons.forEach((radio) => radio.checked = false);
    resetVerificationTypes();
    resetIdsForParticipatorySpaces();
    updateFormState();
  };
  const attachEventListeners = () => {
    var _a;
    inputs.radioButtons.forEach(
      (radio) => radio.addEventListener("change", () => handleRadioChange(radio))
    );
    inputs.checkboxes.forEach(
      (checkbox) => checkbox.addEventListener("change", handleCheckboxChange)
    );
    (_a = selectors.form) == null ? void 0 : _a.addEventListener("change", updateFormState);
  };
  const initializeTomSelect = () => {
    document.querySelectorAll("[data-multiselect='true']").forEach((select) => {
      const tomSelect = new TomSelect(select, {
        plugins: ["remove_button", "dropdown_input"],
        allowEmptyOption: true
      });
      tomSelect.on("change", () => {
        const selectedOptions = tomSelect.getValue();
        if (selectedOptions.includes("all") && selectedOptions.length > 1) {
          tomSelect.setValue(["all"]);
        }
      });
    });
  };
  if (isOnSelectRecipientsPage) {
    attachEventListeners();
    initializeTomSelect();
    updateFormState();
    updateDeliverButtonVisibility();
  }
});
